/** Geohash encode (precision 12) — mirrors community-api-serverless internal/geohash */

const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

function encodeBits(lat, lon, precision) {
  let idx = 0;
  let bit = 0;
  let even = true;
  let latMin = -90;
  let latMax = 90;
  let lonMin = -180;
  let lonMax = 180;
  let hash = '';

  while (hash.length < precision) {
    if (even) {
      const mid = (lonMin + lonMax) / 2;
      if (lon >= mid) {
        idx = idx * 2 + 1;
        lonMin = mid;
      } else {
        idx = idx * 2;
        lonMax = mid;
      }
    } else {
      const mid = (latMin + latMax) / 2;
      if (lat >= mid) {
        idx = idx * 2 + 1;
        latMin = mid;
      } else {
        idx = idx * 2;
        latMax = mid;
      }
    }
    even = !even;
    if (++bit === 5) {
      hash += BASE32[idx];
      bit = 0;
      idx = 0;
    }
  }
  return hash;
}

export function encodeGeohash(lat, lon, precision = 12) {
  return encodeBits(lat, lon, precision);
}

export function prefixForRadiusM(radiusM) {
  if (radiusM <= 50) return 8;
  if (radiusM <= 200) return 7;
  if (radiusM <= 1000) return 6;
  if (radiusM <= 5000) return 5;
  return 4;
}

export function haversineM(lat1, lon1, lat2, lon2) {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function utcDateString(d = new Date()) {
  return d.toISOString().slice(0, 10);
}

export function toRFC3339UTC(d) {
  return new Date(d).toISOString().replace(/\.\d{3}Z$/, 'Z');
}
